export default {"src":"/_next/static/media/moon_regular.e3a153aa.svg","height":24,"width":24};